import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Shield } from "lucide-react";

/**
 * Floating Super Admin button (bottom-right).
 * Only visible if backend confirms current user is in PREMIUM_WHITELIST.
 */
export default function AdminFab() {
  const [isAdmin, setIsAdmin] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/cms/check-admin").then((r) => setIsAdmin(!!r.data?.is_admin)).catch(() => setIsAdmin(false));
  }, []);

  if (!isAdmin) return null;

  return (
    <button
      onClick={() => navigate("/admin")}
      data-testid="btn-admin-fab"
      title="Super Admin CMS"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-gradient-to-br from-amber-400 to-orange-500 text-white font-bold text-lg shadow-2xl hover:scale-110 transition-all flex items-center justify-center ring-4 ring-amber-200/50"
    >
      <Shield className="w-5 h-5 absolute opacity-30" />
      <span className="relative tracking-tight">SA</span>
    </button>
  );
}
